import React from "react";

const Citizen = () => {
  return (
    <div className="bg-[#EAF4FA] max-w-[100vw] p-4 lg:px-4">
      <div className="flex gap-2 items-start flex-wrap md:flex-nowrap">
        <div className="mt-2 text-[#3091D0]">
          <svg
            width="34"
            height="17"
            viewBox="0 0 34 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
              fill="currentColor"
            />
            <path
              d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
              fill="currentColor"
            />
            <circle cx="25.5" cy="8.5" r="8.5" fill="currentColor" />
          </svg>
        </div>

        <div className="flex-1">
          <p className="text-[20px] font-semibold text-black text-left mb-6 uppercase">
            FORM NO 94 ( for Non- Individuals) for citizen of India
          </p>
          
          <div className="bg-white overflow-hidden shadow-sm rounded-lg border border-[#D6E9F6]">
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse text-[12px] md:text-[14px]">
                <thead className="bg-[#D6E9F6]">
                  <tr>
                    <th className="p-3 border border-gray-200 text-center font-bold" style={{ width: "80px" }}>SR NO</th>
                    <th className="p-3 border border-gray-200 text-left font-bold" style={{ width: "250px" }}>Applicant</th>
                    <th className="p-3 border border-gray-200 text-left font-bold">Documents as proof of identity, address and date of birth or date of incorporation</th>
                  </tr>
                </thead>
                <tbody className="text-[#4B4B4B]">
                  {[
                    {
                      sr: "1",
                      app: "Hindu undivided family",
                      doc: (
                        <>
                          (a) Original affidavit by the karta of the Hindu Undivided Family duly authenticated by a Notary Public or Oath Commissioner or Judicial Magistrate stating the name, father's name, Aadhaar number or Permanent Account Number and address of all the coparceners on the date of application; and <br /><br />
                          (b) a copy of any document applicable in the case of an individual specified in serial number 1, in respect of karta of the Hindu undivided family, as proof of identity, address and date of birth.
                        </>
                      )
                    },
                    {
                      sr: "2",
                      app: "Company (registered in India)",
                      doc: (
                        <>
                          (a) Copy of Certificate of Registration issued in India by the Registrar of Companies; or <br />
                          (b) corporate identity number allotted by the Registrar under section 7 of the Companies Act, 2013 (18 of 2013).
                        </>
                      )
                    },
                    {
                      sr: "3",
                      app: "Limited Liability Partnership (formed or registered in India)",
                      doc: (
                        <>
                          (a) Copy of Certificate of Registration issued in India by the Registrar of Limited Liability Partnerships; or <br />
                          (b) LLP identification number allotted in India by the Registrar under the Limited Liability Partnership Act, 2008(6 of 2009).
                        </>
                      )
                    },
                    {
                      sr: "4",
                      app: "Firm (other than Limited Liability Partnership) formed or registered in India",
                      doc: "Firm (other than Limited Liability Partnership) formed or registered in India"
                    },
                    {
                      sr: "5",
                      app: "Trusts (formed or registered in India)",
                      doc: (
                        <>
                          (a) Copy of trust deed; or <br />
                          (b) Copy of Certificate of Registration Number issued by Charity Commissioner.
                        </>
                      )
                    },
                    {
                      sr: "6",
                      app: "Association of persons (other than trusts) or body of individuals formed or registered in India",
                      doc: (
                        <>
                          (a) Copy of agreement; or <br />
                          (b) copy of Certificate of Registration Number issued by Charity Commissioner or Registrar of Cooperative Society or any other competent authority; or <br />
                          (c) any document originating from any Central Government or State Government Department, establishing identity and address of such person.
                        </>
                      )
                    },
                    {
                      sr: "7",
                      app: "Local authority or artificial juridical person (formed or registered in India)",
                      doc: "Any document originating from any Central Government or State Government Department establishing identity and address of such person."
                    },
                    {
                      sr: "8",
                      app: "Any person on behalf of the Central Government or State Government or Union Territory Administration",
                      doc: "Certificate in original from the Head of the Department or Pay and Accounts Officer or Zonal Accounts Officer or District Treasury Officer or Cheque Drawing and Disbursing Officer."
                    }
                  ].map((item, idx) => (
                    <tr key={idx} className="hover:bg-gray-50">
                      <td className="p-3 border border-gray-200 text-center align-top">{item.sr}</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">{item.app}</td>
                      <td className="p-3 border border-gray-200">{item.doc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Citizen;